import { getCurrentDate, IsStoreOpenAtTime } from "../helpers/datetimeHelper";
import {isIos} from "@/api/helpers/uiHelper";
export function getOrderStatus(order) {
  let status;
  if (order.OnlineOrderStatus === 2) {
    status = 1; // Accepted
  } else if (order.OnlineOrderStatus === 4) {
    status = 2; // Ready
  } else if (order.OnlineOrderStatus === 10) {
    status = 5; // Refund
  } else if (order.OnlineOrderStatus === 11) {
    status = -1; // Rejected
  } else if (order.OnlineOrderStatus === 12) {
    status = 6; // Cancel
  } else if (order.OnlineOrderStatus === 3) {
    status = -3; // Failed
  } else if (order.OnlineOrderStatus === 6) {
    status = -2; // Payment Failed
  } else if (order.OnlineOrderStatus === 9) {
    status = 3; // Paid
  } else if (
    order.OnlineOrderStatus === 1 ||
    order.OnlineOrderStatus === 7 ||
    order.OnlineOrderStatus === 8 ||
    order.OnlineOrderStatus == 15
  ) {
    status = 0; // Gray
  } else if (order.OnlineOrderStatus === 5) {
    status = 4; // Complete
  }
  return status;
}

var OrderTypeEnum = {
  OrderTypeEatIn: 2,
  OrderTypeTakeaway: 3,
  OrderTypeBuzzer: 9,
  OrderTypeDelivery: 10,
};

export const orderTypeEnum = OrderTypeEnum;

export function orderTypeSelectionEnabled(company, viewConfig) {
  var now = getCurrentDate(company.TimezoneIanaFormat);
  var storeOpen = IsStoreOpenAtTime(
    company.BlackoutDates,
    company.OperatingHours,
    company.IsInOperation,
    now
  );
  if (!company.EnablePreoderForPickup) {
    now = now.plus({
      minutes: company.OrderPreparationTime,
    });
    storeOpen = IsStoreOpenAtTime(
      company.BlackoutDates,
      company.OperatingHours,
      company.IsInOperation,
      now
    );
  }
  const showDeliveryOption =
    (viewConfig.Delivery && storeOpen) ||
    (viewConfig.Delivery && company.EnablePreoderForDelivery);
  const showPickupOption =
    (viewConfig.PickUp && storeOpen) ||
    (viewConfig.PickUp && company.EnablePreoderForPickup);

  return showDeliveryOption || showPickupOption;
}

export const openLivenUrlSafari = (url) => {
  if(!isIos()){
    window.location.replace(url)
    return
  }

  const wi = window.open('about:blank', '_blank');

  if(!wi){
    window.location.href = url;
  }

  setTimeout(function(){
    // @ts-ignore
    wi.location.replace(url);
  }, 500);
}

